<a [href]=appleAppStore>
    <img src="assets/images/app-store.svg" alt="">
</a>
<div id="space"></div>
<a [href]=googlePlayStore>
    <img src="assets/images/google-play.svg" alt="">
</a>